import { render, staticRenderFns } from "./AdjusmentRules.vue?vue&type=template&id=0ca4cee1"
import script from "./AdjusmentRules.vue?vue&type=script&lang=js"
export * from "./AdjusmentRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports